import React from "react";
import {
  BlueIcon,
  DownloadWithLinesIcon,
  GreenIcon,
  GreyIcon,
  LightBlueIcon,
  OrangeIcon,
  PrintIcon,
  RedIcon,
  ShareIcon,
  UploadIcon,
} from "Assets";
import {
  REPORTS_STATUS_CHANGES,
  REPORTS_LIST_OF_UNITS,
  REPORTS_STATUS_SUMMARY,
  REPORTS_VEHICLE_ASSIGNMENTS_LOG,
  REPORTS_VEHICLE_ASSIGNMENTS_SUMMARY,
  REPORTS_INSPECTIONS_SUBMISSION_SUMMARY,
  REPORTS_INSPECTIONS_SUBMISSION_LIST,
  REPORTS_INSPECTIONS_FAILED_INSPECTIONS,
  REPORTS_VEHICLE_DETAILS,
  REPORTS_OPERATING_COST_SUMMARY,
  REPORTS_ISSUES_LIST,
  REPORTS_SERVICES_REMINDERS,
  REPORTS_WORK_ORDERS_LIST,
  REPORTS_ISSUES_FAULTS_SUMMARY,
  REPORTS_WORK_ORDERS_BY_VEHICLE,
  REPORTS_USERS_RENEWAL_REMINDERS,
  REPORTS_WORK_ORDERS_LABOR_LIST,
  REPORTS_VEHICLES_RENEWAL_REMINDERS,
  REPORTS_PARTS_BY_LOCATION,
  REPORTS_USERS_LIST,
  REPORTS_SERVICES_WITHOUT_SERVICE,
  REPORTS_SERVICE_HISTORY_SUMMARY,
  REPORTS_PURCHASE_ORDERS_LIST,
  REPORTS_PARTS_ACTIVITY,
  REPORTS_SERVICE_HISTORY_BY_VEHICLE,
  REPORTS_COST_COMPARISON_BY_YEAR,
  REPORTS_SERVICE_REMINDER_COMPLIANCE,
  REPORTS_FUEL_ENTRIES_BY_VEHICLE,
  REPORTS_FUEL_SUMMARY,
  REPORTS_FUEL_SUMMARY_BY_LOCATION,
  REPORTS_PART_BY_VEHICLE,
} from "./routes";
export const ReportsTableHeads = [
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  { id: "reportType", label: "Report Type" },
];

export const ReportsListOfUnitsTableHeads = [
  { id: "name", label: "Name" },
  { id: "year", label: "Year" },
  { id: "make", label: "Make" },
  { id: "model", label: "Model" },
  { id: "vin", label: "VIN" },
  { id: "status", label: "Status" },
  { id: "group", label: "Group" },
  { id: "licensePlate", label: "License Plate" },
  { id: "operator", label: "Operator" },
];
export const ReportsInspectionsSubmissionSummary = [
  { id: "name", label: "Name" },
  { id: "submission_count", label: "Submission Count" },
  { id: "forms_count", label: "Forms Count" },
  { id: "average_duration", label: "Average Duration" },
];
export const ReportIssueFaultsSummaryTableHeads = [
  { id: "code", label: "Code" },
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  { id: "critical", label: "Critical" },
  { id: "open", label: "Open" },
  { id: "pending", label: "Pending" },
  { id: "ignored", label: "Ignored" },
  { id: "resolved", label: "Resolved" },
  { id: "last_occurred", label: "Last Occurred" },
];
export const ReportIssueListTableHeads = [
  { id: "issue", label: "Issue" },
  { id: "status", label: "Status" },
  { id: "summary", label: "Summary" },
  { id: "reported_by", label: "Reported By" },
  { id: "assigned", label: "Assigned" },
  { id: "due_date", label: "Due Date" },
  { id: "vehicle", label: "Vehicle" },
];
export const ReportPartsActivityTableHeads = [
  { id: "created_at", label: "Created at" },
  { id: "previous_qty", label: "Previous Qty" },
  { id: "adjustment_qty", label: "Adjustment Qty" },
  { id: "adjustment_type", label: "Adjustment Type" },
  { id: "inventory_adjustment", label: "Inventory Adjustment" },
  { id: "part", label: "Part" },
  { id: "part_location", label: "Part Location" },
  { id: "contact", label: "Contact" },
];

export const ReportServiceReminderTableHeads = [
  { id: "status", label: "Status" },
  { id: "service_task", label: "Service Task" },
  { id: "meter_interval", label: "Meter Interval" },
  { id: "due_meter", label: "Due Meter" },
  { id: "time_interval", label: "Time Interval" },
  { id: "due_date", label: "Due Date" },
  { id: "vehicle", label: "Vehicle" },
  { id: "group", label: "Group" },
];

export const ReportVehicleServiceReminderTableHeads = [
  { id: "service_task", label: "Service Task" },
  { id: "schedule", label: "Schedule" },
  { id: "due", label: "Next Due" },
];
export const ReportVehicleRenewalReminderTableHeads = [
  { id: "type", label: "Renewal Type" },
  { id: "due", label: "Next Due" },
];
export const ReportsInspectionsSubmissionList = [
  { id: "date", label: "Date" },
  { id: "inspection_form", label: "Inspection Form" },
  { id: "duration", label: "Duration" },
  { id: "failed_item", label: " Failed Item" },
  { id: "vehicle", label: "Vehicle" },
  { id: "user", label: "User" },
];
export const ReportsPartsByLocationTableHeads = [
  { id: "name", label: "Part Location" },
  { id: "value", label: "Total Inventory Value" },
  { id: "icon", label: "" },
];
export const ReportsPartsByLocationClickedTableHeads = [
  { id: "part", label: "Part" },
  { id: "description", label: "Description" },
  { id: "category", label: "Category" },
  { id: "cost", label: "Unit cost" },
  { id: "manufacturer", label: "Manufacturer" },
  { id: "bin", label: "Aisle/Row/Bin" },
];
export const ReportsStatusChangesTableHeads = [
  { id: "vehicle", label: "Vehicle" },
  { id: "from", label: "From" },
  { id: "to", label: "To" },
  { id: "user", label: "User" },
  { id: "date", label: "Date" },
];
export const ReportsCostComparisonInServiceTableHeads = [
  { id: "vehicle", label: "Vehicle" },
  { id: "model", label: "Model" },
  { id: "status", label: "Status" },
  { id: "ownership", label: "Ownership" },
  { id: "year1", label: "Year 1" },
  { id: "year2", label: "Year 2" },
  { id: "year3", label: "Year 3" },
  { id: "year4", label: "Year 4" },
  { id: "year5", label: "Year 5" },
  { id: "year6", label: "Year 6" },
  { id: "year7", label: "Year 7" },
  { id: "avg_cost_per_meter", label: "Avg. Cost / Meter" },
];
export const ReportsCodeNameValidate = [
  {
    code_name: "cost-comparison-in-service",
    link: REPORTS_COST_COMPARISON_BY_YEAR,
  },
  {
    code_name: "status-changes",
    link: REPORTS_STATUS_CHANGES,
  },
  {
    code_name: "parts-activity",
    link: REPORTS_PARTS_ACTIVITY,
  },
  {
    code_name: "parts-by-vehicle",
    link: REPORTS_PART_BY_VEHICLE,
  },
  {
    code_name: "service-entries-summary",
    link: REPORTS_SERVICE_HISTORY_SUMMARY,
  },
  {
    code_name: "service-history-by-vehicle",
    link: REPORTS_SERVICE_HISTORY_BY_VEHICLE,
  },
  {
    code_name: "list-of-units",
    link: REPORTS_LIST_OF_UNITS,
  },
  {
    code_name: "parts-by-location",
    link: REPORTS_PARTS_BY_LOCATION,
  },
  {
    code_name: "status-summary",
    link: REPORTS_STATUS_SUMMARY,
  },
  {
    code_name: "renewal-reminders",
    link: REPORTS_VEHICLES_RENEWAL_REMINDERS,
  },
  {
    code_name: "vehicles-without-service",
    link: REPORTS_SERVICES_WITHOUT_SERVICE,
  },
  {
    code_name: "submission-summary",
    link: REPORTS_INSPECTIONS_SUBMISSION_SUMMARY,
  },
  {
    code_name: "inspections-list",
    link: REPORTS_INSPECTIONS_SUBMISSION_LIST,
  },
  {
    code_name: "assignments-log",
    link: REPORTS_VEHICLE_ASSIGNMENTS_LOG,
  },
  {
    code_name: "assignments-summary",
    link: REPORTS_VEHICLE_ASSIGNMENTS_SUMMARY,
  },
  {
    code_name: "failed-inspections",
    link: REPORTS_INSPECTIONS_FAILED_INSPECTIONS,
  },
  {
    code_name: "vehicles-detail",
    link: REPORTS_VEHICLE_DETAILS,
  },
  { code_name: "user-list", link: REPORTS_USERS_LIST },
  {
    code_name: "operating-costs-summary",
    link: REPORTS_OPERATING_COST_SUMMARY,
  },
  {
    code_name: "user-renewal-reminders",
    link: REPORTS_USERS_RENEWAL_REMINDERS,
  },
  {
    code_name: "issues-list",
    link: REPORTS_ISSUES_LIST,
  },
  { code_name: "service-reminder", link: REPORTS_SERVICES_REMINDERS },

  {
    code_name: "service-reminder-compliance",
    link: REPORTS_SERVICE_REMINDER_COMPLIANCE,
  },

  { code_name: "work-orders-list", link: REPORTS_WORK_ORDERS_LIST },
  {
    code_name: "faults-summary",
    link: REPORTS_ISSUES_FAULTS_SUMMARY,
  },
  {
    code_name: "work-orders-by-vehicle",
    link: REPORTS_WORK_ORDERS_BY_VEHICLE,
  },

  {
    code_name: "labor-time-entries-list",
    link: REPORTS_WORK_ORDERS_LABOR_LIST,
  },
  {
    code_name: "purchase-orders-list",
    link: REPORTS_PURCHASE_ORDERS_LIST,
  },
  {
    code_name: "fuel-entries-by-vehicle",
    link: REPORTS_FUEL_ENTRIES_BY_VEHICLE,
  },
  {
    code_name: "fuel-summary",
    link: REPORTS_FUEL_SUMMARY,
  },
  {
    code_name: "fuel-summary-by-location",
    link: REPORTS_FUEL_SUMMARY_BY_LOCATION,
  },
];

export const iconButtonsReports = [
  DownloadWithLinesIcon,
  ShareIcon,
  UploadIcon,
  PrintIcon,
];

export const ReportsStatusSummaryTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  { label: "# Changes", id: "changes" },
  { label: "Active", id: "active", isIconInColumn: <GreenIcon /> },
  {
    label: "Inactive",
    id: "inactive",
    isIconInColumn: <OrangeIcon />,
  },
  { label: "In Shop", id: "in_shop", isIconInColumn: <BlueIcon /> },
  {
    label: "Out of Service",
    id: "out_of_service",
    isIconInColumn: <RedIcon />,
  },

  { label: "Sold", id: "sold", isIconInColumn: <GreyIcon /> },
  { label: "Yes", id: "yes", isIconInColumn: <LightBlueIcon /> },
];

export const ReportServiceReminderComplianceTableHeads = [
  { label: "Due At", id: "date_at" },
  { label: "Completed At", id: "completed_at" },
  { label: "On Time Status", id: "status" },
  { label: "Service Task", id: "service_task" },
  {
    label: "Vehicle",
    id: "vehicle",
  },
  {
    label: "Group",
    id: "group",
  },
  { label: "Due Meter Value", id: "due_meter_value" },
  {
    label: "Completed meter Value",
    id: "completed_meter_value",
  },
];
export const ReportsVehiclesDetailTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  { label: "Year", id: "year" },
  { label: "VIN/SN", id: "vin_sn" },
  { label: "Status", id: "status" },
  { label: "Type", id: "type" },
  { label: "Group", id: "group" },
];
export const ReportsServicesWithoutServiceTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  { label: "Type", id: "type" },
  { label: "Group", id: "group" },
  { label: "Status", id: "status" },
  { label: "Current Operator", id: "operator" },
  { label: "VIN/SN", id: "vin_sn" },
];

export const ReportsServicesHistorySummaryTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  { label: "Type", id: "type" },
  { label: "Group", id: "group" },
  { label: "Status", id: "status" },
  { label: "Last Service Date", id: "date" },
  { label: "# Service Tasks", id: "service_task" },
  { label: "Duration", id: "duration" },
  { label: "Parts", id: "parts" },
  { label: "General Payment", id: "tax" },
  { label: "Total", id: "total" },
];
export const ReportsUserListTableHeads = [
  { label: "Full Name", id: "name" },
  { label: "Group", id: "group" },
  { label: "Email", id: "email" },
  { label: "Employee #", id: "number" },
  { label: "Job Title", id: "job" },
  { label: "Start Date", id: "start_date" },
  { label: "Leave Date", id: "leave_date" },
  { label: "License #", id: "license_number" },
  { label: "License State", id: "license_state" },
  { label: "License Class", id: "license_class" },
];
export const ReportsUsersRenewalRemindersTableHeads = [
  { label: "Status", id: "status" },
  { label: "Renewal Type", id: "type" },
  { label: "Due Date", id: "date" },
  { label: "Contact", id: "contact" },
  { label: "Group", id: "group" },
];
export const ReportsRenewalRemindersTableHeads = [
  { label: "Status", id: "status" },
  { label: "Renewal Type", id: "renewal_type" },
  { label: "Due Date", id: "due_date" },
  { label: "Vehicle", id: "vehicle" },
  { label: "Group", id: "group" },
  { label: "Type", id: "type" },
  { label: "Status", id: "second_status" },
];

export const ReportsPurchaseOrdersListTableHeads = [
  { label: "Purchase Order", id: "po_number" },
  { label: "Status", id: "status" },
  { label: "Description", id: "description" },
  { label: "Part Location", id: "part_location" },
  { label: "Vendor", id: "vendor_name" },
  { label: "Created By", id: "created_by" },
  { label: "Purchased By", id: "purchased_by" },
  { label: "Total Amount", id: "total_amount" },
];

export const reminderStatusWithoutIcon = [
  { label: "Upcoming", value: "upcoming", color: "#FFD700" },
  { label: "Due Soon", value: "due_soon", color: "#EE3529" },
  { label: "Overdue", value: "overdue", color: "#FF5C00" },
];

export const ReportsAssignmentsLogTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  { label: "Operator", id: "operator" },
  { label: "Start Date", id: "start_date" },
  { label: "End Date", id: "end_date" },
  { label: "Duration", id: "duration" },
  { label: "Start Meter", id: "start_meter" },
  { label: "End Meter", id: "end_meter" },
];
export const ReportsFuelEntriesByVehicleTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  { label: "Date of Entry", id: "date" },
  { label: "Fuel Type", id: "fuel_type" },
  { label: "Quantity (Liters)", id: "qty" },
  { label: "Cost per Gallons", id: "cost_per_liter" },
  { label: "Total Cost", id: "total_cost" },
  { label: "Odometer Reading", id: "odometer" },
  { label: "Fuel Efficiency (km/L)", id: "fuel_efficiency" },
  { label: "Fuel_station", id: "fuel_station" },
];
export const ReportsFuelSummaryTableHeads = [
  { label: "Name", id: "name" },
  { label: "Usage", id: "usage" },
  { label: "Gallons (US)", id: "gallons" },
  { label: "Economy", id: "economy" },
  { label: "Total Fuel Cost", id: "total_cost" },
  { label: "Cost/Gallon(US)", id: "cost_per_gallon" },
];
export const ReportsFuelSummaryByLocationTableHeads = [
  { label: "Location", id: "location" },
  { label: "Total Gallons (US)", id: "total_gallons" },
  { label: "Total Fuel Cost", id: "total_cost" },
  { label: "Average Cost per Gallon (US)", id: "average_per_gallon" },
  { label: "Transactions", id: "transactions" },
];
export const ReportsAssignmentsSummaryTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  { label: "# Assignments", id: "assignments" },
  { label: "# Operators", id: "operators" },
  { label: "% Assigned", id: "assigned" },
];
export const ReportsInspectionsFailedTableHeads = [
  { label: "Date", id: "date" },
  {
    label: "Submission",
    id: "submission",
  },
  { label: "Form", id: "form" },
  {
    label: "Item",
    id: "item",
  },
  { label: "Stage", id: "stage" },
  {
    label: "Vehicle",
    id: "vehicle",
  },
];
export const ReportsWorkOrderListTableHeads = [
  { label: "Number", id: "number" },
  {
    label: "Status",
    id: "status",
  },
  { label: "Repair Priority Class", id: "repair" },
  {
    label: "Resolved Issue",
    id: "issues",
  },
  { label: "Issue Date", id: "issue_date" },
  {
    label: "Schedule Start Date",
    id: "start_date",
  },
  {
    label: "Expected Completion Date",
    id: "completion_date",
  },
  {
    label: "Driver",
    id: "driver",
  },
  {
    label: "Total Cost",
    id: "total_cost",
  },
];
export const ReportsWorkOrderByVehicleTableHeads = [
  { label: "Work Order Number", id: "number" },
  {
    label: "Status",
    id: "status",
  },
  { label: "Description", id: "description" },
  {
    label: "Vendor",
    id: "vendor",
  },
  { label: "Assigned To", id: "assigned_to" },
  {
    label: "Issue Date",
    id: "issue_date",
  },
  {
    label: "Issue By",
    id: "issue_by",
  },
  {
    label: "Actual Start Date",
    id: "start_date",
  },
  {
    label: "Actual Completion Date",
    id: "completion_date",
  },
  { label: "Line Item Count", id: "item_count" },
  {
    label: "Service Task",
    id: "service_task",
  },
  { label: "Resolved Issues", id: "resolved_issues" },
  { label: "Discount", id: "discount" },
  {
    label: "Labor Subtotal",
    id: "labor_subtotal",
  },
  {
    label: "Parts Subtotal",
    id: "parts_subtotal",
  },
  {
    label: "Total",
    id: "total",
  },
];
export const ReportsWorkOrderLaborListTableHeads = [
  { label: "Name", id: "name" },
  {
    label: "Vehicle #",
    id: "vehicle",
  },
  { label: "Service Task", id: "service_task" },
  {
    label: "Start Time",
    id: "start_time",
  },
  { label: "End Time", id: "end_time" },
  {
    label: "Total Spent Time",
    id: "total_time",
  },
  {
    label: "Date of Service",
    id: "date",
  },
  {
    label: "Comments",
    id: "comments",
  },
];
export const ReportsOperatingCostsSummaryTableHeads = [
  { label: "Vehicle", id: "vehicle" },
  {
    label: "Service Costs",
    id: "service_costs",
  },
  { label: "Fuel Costs", id: "fuel_costs" },
  {
    label: "Other Costs",
    id: "other_costs",
  },
  { label: "Total Costs", id: "total_costs" },
  {
    label: "Cost/Meter",
    id: "cost_meter",
  },
];
export const ReportsPartByVehicleTableHeads = [
  { label: "Vehicle", id: "vehicle_name" },
  {
    label: "Group",
    id: "group_name",
  },
  { label: "Year", id: "year" },
  {
    label: "Make",
    id: "make",
  },
  {
    label: "Modal",
    id: "modal",
  },
  { id: "icon", label: "" },
];
export const ReportsPartsByVehilceClickedTableHeads = [
  { label: "Part", id: "part_name" },
  {
    label: "Category",
    id: "category",
  },
  { label: "Work Order", id: "work_order" },
  {
    label: "Status",
    id: "work_order_status",
  },
  {
    label: "Completion Date",
    id: "completion_date",
  },
  { id: "unit_cost", label: "Part unit price" },

  { id: "quantity", label: "Part quantity" },
  { id: "total_cost", label: "Part subtotal" },
];

export const ReportsServiceHistoryByVehicleTableHeads = [
  { label: "Service Entry", id: "number" },
  {
    label: "Actual Start Date",
    id: "start_date",
  },
  {
    label: "Actual Completion Date",
    id: "completion_date",
  },
  {
    label: "Duration",
    id: "duration",
  },
  { label: "Vendor", id: "vendor" },
  {
    label: "Service Task",
    id: "service_task",
  },
  {
    label: "Labor Subtotal",
    id: "labor_subtotal",
  },
  {
    label: "Parts Subtotal",
    id: "parts_subtotal",
  },
  {
    label: "Total",
    id: "total",
  },
];
export const ReportsVehicleListTableHeads = [
  { id: "vehicle", label: "Vehicle" },
];
